import React, { useContext, Fragment } from 'react';
import { ConfigurationContext } from '../../Context/Configuration';
import YouTube from 'react-youtube';
import { ReactCompareSlider, ReactCompareSliderImage, ReactCompareSliderHandle } from 'react-compare-slider';
import { RedButton } from '../Buttons/Buttons';
import './Product.scss';
import QuizBanner from '../QuizBanner/QuizBanner';
import TextButtonBanner from '../TextButtonBanner/TextButtonBanner';
import CircularTable from '../CircularTable/CircularTable';
import ImageRow, { ImageRowForSlides } from '../ImageRow/ImageRow';
import 'resize-observer-polyfill/dist/ResizeObserver.global'

const Product = (props) => {
	var pStatus =  "®" //(props.details.name == 'Smoulder' || props.details.name == 'Voraxor') ? "™" : "®";
	var nameR = '<span>' + props.details.name + '<sup style="font-size:0.45em">'+pStatus+'</sup>' + '</span>';
	return (
		<React.Fragment>

			<div className='container'>
				<img className="productLogo" src={props.details.productLogo} alt={`${props.details.name} logo`}></img>
				<h1 dangerouslySetInnerHTML={{ __html: props.details.headline }}></h1>
				<p className="headingText" dangerouslySetInnerHTML={{ __html: props.details.heading }}></p>

				<YouTube

					videoId={props.details.videoURL}
					opts={{
						playerVars: {
							autoplay: 0,
							controls: 1,
							rel: 0,
							playsinline: 1
						},
						width: '100%',
						height: '600px',
					}}
				>
				</YouTube>

				<hr style={{ marginTop: `1.5em` }} />

				<h1>
					What {props.details.name} brings to the table.
				</h1>

				{/*<div className="showForDesktop" dangerouslySetInnerHTML={{ __html: Benefits}}></div>*/}
				<div className="showForDesktop">
					<CircularTable name={props.details.name} />
				</div>

				<div className="benefits showForMobile">
					<div>
						<div className="benefits_head" dangerouslySetInnerHTML={{ __html: nameR }}></div>
						<div className="benefits_desc">Herbicide</div>
					</div>

					{props.details.tableContents.map((elem, index) => ((
						<div key={index}>
							<div>{elem.title}</div>
							<div>{elem.text}</div>
						</div>
					)))}
				</div>

				<hr />

				<h1>
					{props.details.name} in the field.
				</h1>

				<div className={`slider`}>
					<ReactCompareSlider className={`withSlider ${props.details.name.toLowerCase()}`}
						style={{ height: `568px` }, { width: `568px` }}
						handle=
						{
							<ReactCompareSliderHandle buttonStyle={{ WebkitBackdropFilter: undefined, backdropFilter: undefined, backgroundColor: 'white', border: 0, boxShadow: undefined, color: '#444' }} linesStyle={{ opacity: 0.5 }} />
						}

						itemOne={
							<ReactCompareSliderImage
								src={props.details.treated[0]}
								alt={props.details.treated[1]}
							/>
						}

						itemTwo={
							<ReactCompareSliderImage
								src={props.details.untreated[0]}
								alt={props.details.untreated[1]}
							/>
						}
					/>
					<img
						style={{ height: `568px` }, { width: `568px` }}
						className={`withoutSlider ${props.details.name.toLowerCase()}`}
						src={props.details.treated[0]}
						alt={props.details.treated[1]}>
					</img>
				</div>

				<div className="showForDesktop">
					{props.details.imageRowContents.map((elem, index) => ((
						<ImageRow key={index} contents={elem}></ImageRow>
					)))}
				</div>

				<div className="showForMobile">
					<ImageRowForSlides contents={props.details.imageRowContents}></ImageRowForSlides>
				</div>

			</div>

			<TextButtonBanner
				title={'Learn more about ' + props.details.name + "."}
				text={props.details.learnMore}
				button_text="Product Page"
				button_link={props.details.pageLink}
				cropImage={props.details.cropImage}
			/>

		</React.Fragment>
	);
}

export default Product;